// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIrsLimitLiteDto
 */
export interface IIrsLimitLiteDto {
    /**
     * 
     * @type {string}
     * @memberof IIrsLimitLiteDto
     */
    type?: IIrsLimitLiteDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IIrsLimitLiteDto
     */
    irs_coverage_level_type?: IIrsLimitLiteDtoIrsCoverageLevelTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIrsLimitLiteDtoTypeEnum {
    HCFSA_MAX = 'HCFSA_MAX',
    HSA_MAX = 'HSA_MAX',
    DCAP_MAX = 'DCAP_MAX',
    TRANSIT_MAX = 'TRANSIT_MAX',
    PARKING_MAX = 'PARKING_MAX',
    HCFSA_EE_ER_MAX = 'HCFSA_EE_ER_MAX'
}
/**
* @export
* @enum {string}
*/
export enum IIrsLimitLiteDtoIrsCoverageLevelTypeEnum {
    FAMILY = 'FAMILY',
    INDIVIDUAL = 'INDIVIDUAL',
    ROLLOVER = 'ROLLOVER'
}


/**
 * Check if a given object implements the IIrsLimitLiteDto interface.
 */
export function instanceOfIIrsLimitLiteDto(value: object): value is IIrsLimitLiteDto {
    return true;
}

export function IIrsLimitLiteDtoFromJSON(json: any): IIrsLimitLiteDto {
    return IIrsLimitLiteDtoFromJSONTyped(json, false);
}

export function IIrsLimitLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIrsLimitLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'irs_coverage_level_type': json['irs_coverage_level_type'] == null ? undefined : json['irs_coverage_level_type'],
    };
}

export function IIrsLimitLiteDtoToJSON(json: any): IIrsLimitLiteDto {
    return IIrsLimitLiteDtoToJSONTyped(json, false);
}

export function IIrsLimitLiteDtoToJSONTyped(value?: IIrsLimitLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'irs_coverage_level_type': value['irs_coverage_level_type'],
    };
}

